import { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import AuthLayout from "../components/layout/AuthLayout";
import Spinner from "react-bootstrap/esm/Spinner";
import MainLayout from "../components/layout/MainLayout";
import Error from "../components/layout/Error";
import { tokenLoader } from "../utils/auth";
import AddProductPage from "../pages/main/AddProduct/AddProductPage";


const lazyRetry = function (componentImport) {
  // debugger
  return new Promise((resolve, reject) => {
    // try to import the component
    // debugger
    componentImport()
      .then((component) => {
        // debugger
        resolve(component);
      })
      .catch((error) => {
        // TO DO
        // debugger;
        console.log(error);
        window.location.reload();
        reject(error); // there was an error
      });
  });
};

// const LoginPage = lazy(() =>
//   lazyRetry(() => import("../pages/auth/login/LoginPage"))
// );
const SignUpPage = lazy(() =>
  lazyRetry(() => import("../pages/auth/signup/SignUpPage"))
);
const ForgotPasswordPage = lazy(() =>
  lazyRetry(() => import("../pages/auth/forgetpassword/ForgotPassword"))
)
const CodeVerificationPage = lazy(() =>
  lazyRetry(() => import("../pages/auth/codeverification/CodeVerification"))
)
const ConfirmPasswordPage = lazy(() =>
  lazyRetry(() => import("../pages/auth/confirmpassword/ConfirmPassword"))
)

/////////////////// Products
const ProductsPage = lazy(() =>
  lazyRetry(() => import("../pages/main/products/ProductsPage"))
)
const ProductsProfilePage = lazy(() =>
  lazyRetry(() => import("../pages/main/productProfile/ProductProfilePage"))
)

/////////////////// Stocks
const StocksPage = lazy(() =>
  lazyRetry(() => import("../pages/main/stocks/StockManagement"))
)

/////////////////// CatalogManagement
const CategoryManagementPage = lazy(() =>
  lazyRetry(() => import("../pages/main/CatalogManagement/CatalogManagement"))
)

const AttributesManagementPage = lazy(() =>
  lazyRetry(() => import("../pages/main/AttributesManagement/AttributesManagement"))
)

const AccessRequestPage = lazy(() =>
  lazyRetry(() => import("../pages/auth/accessRequest/AccessRequestPage"))
);

const PromomCodePage = lazy(() =>
  lazyRetry(() => import("../pages/main/promoCodes/PromoCodesManagement"))
);

const StatesPage = lazy(() =>
  lazyRetry(() => import("../pages/main/statesManagement/StatesManagement"))
);

const OrdersManagementPage = lazy(() =>
  lazyRetry(() => import("../pages/main/ordersManagement/OrdersManagement"))
);


const Loading = (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    }}
  >
    <Spinner as="span" animation="border" variant="black" />
    {/* Loading..... */}
  </div>
);

export const router = createBrowserRouter([
  {
    path: "auth",
    errorElement: <Error />,
    loader: tokenLoader,
    element: <AuthLayout />,
    children: [
      // {
      //   index: true,
      //   element: (
      //     <Suspense fallback={Loading}>
      //       <LoginPage />
      //     </Suspense>
      //   ),
      // },
      {
        path: "access-request",
        element: (
          <Suspense fallback={Loading}>
            <AccessRequestPage />
          </Suspense>
        ),
      },
      {
        path: "sign-up",
        element: (
          <Suspense fallback={Loading}>
            <SignUpPage />
          </Suspense>
        )
      },
      {
        path: "forgot-password",
        element: (
          <Suspense fallback={Loading}>
            <ForgotPasswordPage />
          </Suspense>
        ),
      },
      {
        path: "code-verification",
        element: (
          <Suspense fallback={Loading}>
            <CodeVerificationPage />
          </Suspense>
        ),
      },
      {
        path: "confirm-password",
        element: (
          <Suspense fallback={Loading}>
            <ConfirmPasswordPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <ProductsPage />
          </Suspense>
        ),
      }
    ],
  },
  {
    path: "products",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <ProductsPage />
          </Suspense>
        ),
      },
      {
        path: ":productId",
        element: (
          <Suspense fallback={Loading}>
            <ProductsProfilePage />
          </Suspense>
        ),
      },
      {
        path: "add",
        element: (
          <Suspense fallback={Loading}>
            <AddProductPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "stocks",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <StocksPage />
          </Suspense>
        ),
      }
    ],
  },
  {
    path: "catalog-management",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <CategoryManagementPage />
          </Suspense>
        ),
      }
    ],
  },
    {
    path: "attributes-management",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <AttributesManagementPage />
          </Suspense>
        ),
      }
    ],
  },
  {
    path: "promo-codes",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <PromomCodePage />
          </Suspense>
        ),
      }
    ],
  },
  {
    path: "states",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <StatesPage />
          </Suspense>
        ),
      }
    ],
  },
  
  {
    path: "orders-management",
    errorElement: <Error />,
    element: <MainLayout />,
    children:[
      {
        index: true,
        element: (
          <Suspense fallback={Loading}>
            <OrdersManagementPage />
          </Suspense>
        ),
      }
    ],
  },
  {
    path: "*",
    errorElement: <Error />,
    element: <Error />
  }
]);